module.exports = __webpack_public_path__ + "static/media/personal-chef.d2ae9e05.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personal-chef.jpeg
// module id = 1617
// module chunks = 0